import toFixedNumberUtil from 'utils/number/to-fixed'

/**
 * @param value
 * @param [options]
 * @param options.ignoreZeroDecimals
 * @param options.precision
 * @param options.dontRoundNextPrecision
 * @returns {`$${*}`|`$${number}`}
 */
export default function getPriceLabelStringUtil (value, options) {
  const precision = options?.precision || 3
  const floatValueStr = value.toFixed(precision)
  const [, decimals] = floatValueStr.split('.')

  if (
    options?.ignoreZeroDecimals &&
    decimals === '000'
  ) {
    return `$${parseInt(value, 10)}`
  }

  const floatValue = parseFloat(floatValueStr)
  const floatValueStrFixed = toFixedNumberUtil(floatValue, 2, options)
  return `$${floatValueStrFixed}`
}
